export function label(names: [string, string], nb: number): string {
  if (nb === 1) {
    return singular(names);
  } else {
    return plural(names);
  }
}

export function singular(names: [string, string]): string {
  return names[0];
}

export function plural(names: [string, string]): string {
  return names[1];
}
